export const types = {
  brasindice: 'Brasíndice',
  cbhpm: 'CBHPM',
  simpro: 'Simpro',
  fixed_table: 'Tabela fixa',
};

export function getName(value) {
  return types[value];
}
